import { appSettings } from '@/settings/app-settings';

import createHttpClient from './http-client';

const httpClient = createHttpClient(appSettings.api.ASSET_MANAGER_URL || '');

export const fetchEmployees = async (params: {
  limit: number;
  offset: number;
  status?: string;
  name?: string;
  vendorId?: string;
}) => {
  try {
    const response = await httpClient.get(`employee/fetch`, { params });
    return response.data;
  } catch (error) {
    console.log('Error while fetching employees');
    throw error;
  }
};

export const deleteEmployee = async (id: string) => {
  try {
    const response = await httpClient.delete(`/employee/delete/${id}`);
    return response.data;
  } catch (error) {
    console.log('Error while deleting employee');
    throw error;
  }
};

export const fetchEmployeeBusinesses = async (params?: { limit?: number; offset?: number }) => {
  try {
    const response = await httpClient.get(`/employee/fetch-businesses`, { params });
    return response.data;
  } catch (error) {
    console.log('Error while fetching employee businesses');
    throw error;
  }
};

export const fetchEmployeePortals = async (
  id: string,
  params: { limit: number; offset: number; vendorId: string },
) => {
  try {
    const response = await httpClient.get(`/employee/fetch-portals/${id}`, { params });
    return response.data;
  } catch (error) {
    console.log('Error while fetching employee portals');
    throw error;
  }
};

export const checkEmployeeVendor = async (vendorId: string) => {
  try {
    const response = await httpClient.get(`/employee/check?vendorId=${vendorId}`);
    return response.data;
  } catch (error) {
    console.log('Error while checking employee vendor');
    throw error;
  }
};

export const checkVendorAdmin = async (vendorId: string) => {
  try {
    const response = await httpClient.get(`/employee/check-admin?vendorId=${vendorId}`);
    return response.data;
  } catch (error) {
    console.log('Error while checking admin employee vendor');
    throw error;
  }
};

export async function updateSupportRoles(employeeId: string, body: any) {
  try {
    const response = await httpClient.put(`/employee/update-support-roles/${employeeId}`, body);
    return response?.data;
  } catch (error) {
    console.log('Error while updating support roles');
    throw error;
  }
}

export async function fetchEmployeeContact(id: string) {
  try {
    const response = await httpClient.get(`/messaging-system/${id}/fetch-employee-contact`);
    return response?.data;
  } catch (error) {
    console.log('Error while fetching employee contact from message id');
    throw error;
  }
}

export async function AddEmployeeContact(body: {
  vendorId: string;
  supportType: 'INVOICE';
  employeeIds: string[];
}) {
  try {
    const response = await httpClient.patch(`/messaging-system/add-customer-support-employee`, body);
    return response?.data;
  } catch (error) {
    console.log('Error while adding employee contact');
    throw error;
  }
}

export async function RemoveEmployeeContact(body: {
  vendorId: string;
  supportType: 'INVOICE';
  employeeIds: string[];
}) {
  try {
    const response = await httpClient.patch(`/messaging-system/remove-customer-support-employee`, body);
    return response?.data;
  } catch (error) {
    console.log('Error while removing employee contact');
    throw error;
  }
}

export async function sendCustomerSupportReply(entityId: string, body: any) {
  try {
    // const response = await httpClient.post(`/shared-space/send-customer-support-reply/${entityId}`, body);
    const response = await httpClient.post(`/threads/send-thread-message/${entityId}`, body);
    return response?.data;
  } catch (error) {
    console.log('Error while sending customer support replay');
    throw error;
  }
}
